import bizopp from './bizopp'
import shop from './shop'
import shopDetail from './shopDetail'
import shopDetailBR from './shopDetail-BR'
import shopDetailJP from './shopDetail-JP'
import shopDetailCR from './shopDetail-CR'
import map from './map'
import gasMap from './gasMap'
import sign from './sign'
import visit from './visit'
import visitV2 from './visitV2'
import task from './task'
import visitList from './visitList'
import partySign from './partySign'
import shopSign from './shopSign'
import performance from './performance'
import accompanyVisit from './accompanyVisit'
import upgrade from './upgrade'
import bizoppV2 from './bizoppV2'
import store from './store'
import searchStore from './searchStore'
import gasSearchStore from './gasSearchStore'
import bizoppDetailV2 from './bizoppDetailV2'
import guidance from './guidance'
import gasBizoppDetail from './gasBizoppDetail'
import gasStore from './gasStore'
import salesTask from './salesTask'
import violation from './violation'
import projectAction from './projectAction'
export default {
  bizopp,
  bizoppV2,
  shop,
  shopDetail,
  shopDetailBR,
  shopDetailJP,
  shopDetailCR,
  map,
  gasMap,
  sign,
  visit,
  visitV2,
  task,
  visitList,
  partySign,
  shopSign,
  performance,
  accompanyVisit,
  upgrade,
  store,
  searchStore,
  gasSearchStore,
  bizoppDetailV2,
  guidance,
  salesTask,
  violation,
  projectAction,
  /** 以下是油站的sotre */
  gasBizoppDetail,
  gasStore,
}
